import { inject, Injectable } from '@angular/core';
import { LoginResponse, OidcSecurityService } from 'angular-auth-oidc-client';
import { lastValueFrom, Observable } from 'rxjs';

import { LocalStorageService } from 'projects/shared/src/lib/core/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly localStorageService = inject(LocalStorageService);

  public async checkAutharize(): Promise<LoginResponse> {
    return await lastValueFrom(this.oidcSecurityService.checkAuth());
  }

  public authorize() {
    return this.oidcSecurityService.authorize();
  }

   public async getRefreshToken(): Promise<string> {
    return await lastValueFrom(this.oidcSecurityService.getRefreshToken());
  }

  // Local data cleanup only & keeping tokens and session
  // Needed to be as logout() but synchronous
  public logoutLocal() {
    this.oidcSecurityService.logoffLocal();
    this.localStorageService.clear();
  }

  // Tokens invalidation & local data cleanup
  public async logout() {
    try {
      // manual tokens revocation
      await lastValueFrom(this.oidcSecurityService.revokeAccessToken());
      await lastValueFrom(this.oidcSecurityService.revokeRefreshToken());
    } finally {
      // clean up local data
      this.logoutLocal();
    }
  }

  // Tokens invalidation & local data cleanup & end session on IdP
  public async centralLogout(): Promise<void> {
    // tokens revocation
    // session logout

    //await lastValueFrom(this.oidcSecurityService.logoffAndRevokeTokens());
    try {
      await lastValueFrom(this.oidcSecurityService.revokeAccessToken());
      await lastValueFrom(this.oidcSecurityService.revokeRefreshToken());
    } finally {
      try {
        await lastValueFrom(this.oidcSecurityService.logoff());
      } catch {
        this.logoutLocal();
      } finally {
        this.localStorageService.clear();
      }
    }
  }

  public forceRefreshSession(): Observable<LoginResponse> {
    return this.oidcSecurityService.checkAuthIncludingServer();
  }
}
